import React from "react";
import "./App.css";
import { RoutesApp } from "./pages/RoutesApp";

export const App = () => (
  <RoutesApp />
);
